import { render, staticRenderFns } from "./PcPcmRegnContent.vue?vue&type=template&id=833c4bf0&"
import script from "./PcPcmRegnContent.vue?vue&type=script&lang=js&"
export * from "./PcPcmRegnContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports